import NotesGridCell from './NotesGridCell.svelte';
import { Slugs } from '@thinkalpha/common/constants/slugs.js';
import { FieldTypeCategory } from '@thinkalpha/language-services';
import type { TemplateColumn } from '@thinkalpha/ui-types/contracts/column-template';
import { registerClientColumn } from 'src/features/clientColumns';
import type { ClientColumnDefinition } from 'src/features/clientColumns';
import { generateDefaultDisplaySetting } from 'src/routes/dashboard/widget-container/widget-settings-editor/context';
import { v4 } from 'uuid';

/** The clientKey for the Notes column type */
export const NOTES_CLIENT_KEY = 'notes';

/**
 * Creates a new Notes client column for use in column templates.
 */
export function createNotesClientColumn(): TemplateColumn {
    return {
        id: v4(),
        name: 'Notes',
        type: 'client',
        clientKey: NOTES_CLIENT_KEY,
        dataType: FieldTypeCategory.String,
        unit: null,
        visible: true,
        displaySettings: [generateDefaultDisplaySetting()],
    };
}

/**
 * Client column definition for Notes.
 * This is registered with the clientColumnRegistry.
 */
// Tracks whether the first grid cell has started the notes service initialization.
let gridCellInitializationStarted = false;

export const notesClientColumnDefinition: ClientColumnDefinition = {
    clientKey: NOTES_CLIENT_KEY,
    displayName: 'Notes',
    tableKey: 'strategy',
    requiredSlugs: [Slugs.symbol],
    createGridCell: ({ resolvedFieldIds, container }) => {
        const notesService = container.get('SymbolNotesService');
        // Lazily initialize the notes service when the first grid cell resolves.
        if (!gridCellInitializationStarted) {
            gridCellInitializationStarted = true;
            void notesService.initialize();
        }
        return {
            component: NotesGridCell,
            props: { symbolFieldId: resolvedFieldIds?.[Slugs.symbol] ?? '', notesService },
        };
    },
    createColumn: createNotesClientColumn,
};

/**
 * Register the Notes client column with the registry.
 * This should be called during application initialization.
 */
export function registerNotesClientColumn(): void {
    registerClientColumn(notesClientColumnDefinition);
}
